import {
  enumBoxStyleSearch,
  enumBrand,
  enumChartTemplateSet,
  enumObjClassNames
} from "../constants";
import { gWhiteLabel } from "../whitelabel/brand";
import { QList } from "./QList";
import { QListMgr } from "./QListMgr";
import { QView } from "./QView";
import { QXMLObject } from "./QXMLObject";

export class QViewMgr extends QXMLObject {
  constructor() {
    super();
    this.fViewList = null;
    //  this.fDoc = null;
    this.fWSMgr = null;

    this.fInteractiveView = null;
    this.fListMgr = null;

    this.fFieldList = null;
  }

  GetRootLayout() {
    // Gets root layout, handling fallback as necessary. Fallback occurs when no interactive view is loaded or when there is no root layout found.
    var fallback = false;
    var doc = this.fWSMgr.GetDoc();
    var interactiveView = this.GetInteractiveView(doc);
    var chartTemplatesManager = this.GetWSMgr().GetChartTemplatesMgr();
    var systemDefaultTemplateClone = chartTemplatesManager.GetSystemDefaultTemplate().Clone();
    if (!interactiveView) {
      // fall back to default system template if none available
      fallback = true;

      interactiveView = systemDefaultTemplateClone;
      this.SetInteractiveView(interactiveView);
    }

    if (!interactiveView.fRootLayout) {
      var rootLayout = this.GetPreviewLayout();

      interactiveView.fRootLayout = rootLayout.Clone();
      doc.FinishLoadLayout(interactiveView.fRootLayout);
      interactiveView.fRootLayout.fBoxStyleID = rootLayout.GetBoxStyleID();
    }

    this.SetInteractiveView(interactiveView);
    var layout = interactiveView.fRootLayout;

    return [layout, fallback];
  }

  GetPreviewLayout() {
    var interactiveView = this.GetInteractiveView();
    var rootBoxStyleID = interactiveView.GetRootBoxStyleID();
    var boxStylesManager = this.GetWSMgr().GetBoxStylesMgr();
    var layout = boxStylesManager.GetLayoutByID(rootBoxStyleID, false, enumBoxStyleSearch.allSets);
    if (!layout) {
      layout = boxStylesManager.GetSystemDefaultLayout();
    }
    return layout;
  }

  InitViewMgr(wsMgr) {
    this.SetXMLElementName("viewmgr");
    this.fWSMgr = wsMgr;
    this.fViewList = [];
    this.fListMgr = new QListMgr();
  }

  ResetViewMgr() {
    this.fViewList = [];
  }

  GetViewList() {
    return this.fViewList;
  }

  SetViewList(viewList) {
    this.fViewList = viewList;
  }

  /**
   * Returns a list of view IDs that the current user is allowed to access for the current chart.
   * If the user has admin permissions or if there are no view restrictions, all views are returned.
   * If the current user is not allowed to access any views, an empty list is returned.
   * @returns {Array} An array of view IDs that the current user is allowed to access.
   */
  GetAllowedViewList(checkChartID = null) {
    var myGroupID = this.fWSMgr.GetUserGroupID();
    if (myGroupID == "0")
      return this.fViewList.map(function (a) {
        return a.GetViewID();
      });

    var myGroup = this.fWSMgr.GetCurrentUserGroup();
    if (!myGroup) return [];

    var currentOpenChartID = this.fWSMgr.GetDoc()?.GetChartID();
    var myChartID = checkChartID ?? currentOpenChartID;

    var allowedViewsPerSecGroup = myGroup.GetAllowedViewsFromChartID(myChartID);
    if (!allowedViewsPerSecGroup) return [];

    return this.fViewList.reduce(function (doubleFilteredList, view) {
      let viewID = view.GetViewID();
      if (allowedViewsPerSecGroup.includes(viewID)) doubleFilteredList.push(viewID);
      return doubleFilteredList;
    }, []);
  }

  GetNumViews() {
    return this.fViewList.length;
  }

  GetIndexView(index) {
    return this.fViewList[index];
  }

  GetViewByID(viewID) {
    var n = this.GetNumViews();
    var b = viewID.toLowerCase();

    for (var i = 0; i < n; i++) {
      var v = this.GetIndexView(i);
      var a = v.GetViewID();
      a = a.toLowerCase();
      if (a == b) return v;
    }
    return null;
  }

  GetViewIndex(aView) {
    var index = this.fViewList.indexOf(aView);
    return index;
  }

  GetDoc() {
    var theDoc = this.fWSMgr.GetDoc();
    return theDoc;
  }

  GetWSMgr() {
    return this.fWSMgr;
  }

  ShuffleView(aView, shuffleUp) {
    var index = this.GetViewIndex(aView);
    var n = this.GetNumViews();
    var newIndex;

    if (shuffleUp) newIndex = index - 1;
    else newIndex = index + 1;

    if (newIndex < 0) return;
    if (newIndex >= n) return;

    var t = this.fViewList[newIndex];
    this.fViewList[newIndex] = aView;
    this.fViewList[index] = t;

    var theDoc = this.GetDoc();
    if (theDoc) theDoc.SetDirty(true);
  }

  RemoveView(aView) {
    var index = this.fViewList.indexOf(aView);
    if (index != -1) {
      this.fViewList.splice(index, 1);
    }

    return index;
  }

  CopyViews(srcViewMgr) {
    if (this.GetNumViews() > 0)
      //Legacy documents refreshing copy their views from the previous
      return;

    var n = srcViewMgr.GetNumViews();
    for (var i = 0; i < n; i++) {
      var v = srcViewMgr.GetIndexView(i);
      var newView = v.Clone();
      this.fViewList.push(newView);
    }
  }

  AddView(viewID) {
    var v = new QView();
    v.InitView(viewID);

    if (this.GetViewByID(viewID) != null) return;

    this.fViewList.push(v);

    let ctm = this.fWSMgr.GetChartTemplatesMgr();
    let view = ctm.FindTemplateByIDAllSets(viewID);
    v.fName = view["template"].fTemplateName;
  }

  OutputChildElements(stream) {
    var n = this.GetNumViews();
    for (var i = 0; i < n; i++) {
      var v = this.GetIndexView(i);
      v.OutputToXML(stream);
    }
  }

  LoadChildElements(objTree) {
    var childList = objTree.GetChildOfTypeList("view");
    var numRows = childList.length;

    for (var i = 0; i < numRows; i++) {
      var rowInfo = childList[i];
      var aRow = new QView();
      aRow.LoadFromXML(rowInfo);
      this.AddView(aRow.GetViewID());
    }
  }

  OutputToJSON(json) {
    json["views"] = {};
    var views = json["views"];
    views["viewList"] = []; //Keeping it more modular if needed

    var n = this.GetNumViews();
    for (var i = 0; i < n; i++) {
      var v = this.GetIndexView(i);
      v.OutputToJSON(views["viewList"]);
    }
  }

  LoadFromJSON(JSON) {
    var viewList = JSON["viewList"];
    var numRows = viewList.length;

    for (var i = 0; i < numRows; i++) {
      var rowInfo = viewList[i];
      var aRow = new QView();
      aRow.LoadFromJSON(rowInfo);
      this.AddView(aRow.GetViewID());
    }
  }

  GetUnusedTemplates(objectResponse) {
    var ctm = this.fWSMgr.GetChartTemplatesMgr();
    var sharedTemplates = ctm.GetTemplateList(enumChartTemplateSet.sharedtemplates, false);
    var defSysTemplates = ctm
      .GetTemplateList(enumChartTemplateSet.systemtemplates)
      .filter(function (aTemplate) {
        if (gWhiteLabel === enumBrand.isolved) {
          return aTemplate.fTemplateSet === enumBrand.isolved;
        }
        return aTemplate.fTemplateSet == "ADP";
      });

    var totalList = defSysTemplates.concat(sharedTemplates);
    var unusedList = [];

    for (var i in totalList) {
      var uTemp = totalList[i];
      var uTempName = uTemp.GetTemplateID();
      var v = this.GetViewByID(uTempName);
      if (v == null) {
        objectResponse ? unusedList.push(uTemp) : unusedList.push(uTempName);
      }
    }

    return unusedList;
  }

  GetInteractiveView(doc) {
    // returns a chart template which is used to display a single styled chart box (used in chart builder).
    if (this.fInteractiveView == null && doc != null) {
      var activeTemplate = doc.GetActiveTemplate();
      if (activeTemplate) {
        this.fInteractiveView = activeTemplate.Clone();
      }
    }
    if (this.fInteractiveView == null && this.fParentPanel != null) {
      this.fInteractiveView = this.fParentPanel.GetInteractiveView();
    }
    return this.fInteractiveView;
  }

  SetInteractiveView(interactiveView) {
    this.fInteractiveView = interactiveView;
  }

  /**
   * @param {string=} className
   * @returns {string[]}
   */
  GetFieldList(className = enumObjClassNames.box) {
    var w = this.fWSMgr;
    var doc = w.GetDoc();
    var fieldList = [];

    if (!doc) return fieldList;

    var docMgr = doc.GetDocMgr();
    var l = docMgr.GetProfileList(className);
    var n = l.length;

    for (var i = 0; i < n; i++) {
      var profileRow = l[i];
      var fieldDef = profileRow.GetFieldDef();
      if (fieldDef != null) {
        var fieldName = fieldDef.GetFieldName();
        fieldList.push(fieldName);
      }
    }

    return fieldList;
  }

  HandleUpdateBox() {
    var wsMgr = this.fWSMgr;
    var doc = wsMgr.GetDoc();
    var list = this.fFieldList;
    //Clone the view and refer
    var [layout, fallback] = this.GetRootLayout();
    var iView = this.GetInteractiveView();
    var rootBStyleID = iView.GetRootBoxStyleID();
    var baseLayout = this.fWSMgr
      .GetBoxStylesMgr()
      .GetLayoutByID(rootBStyleID, true, enumBoxStyleSearch.allSets);
    doc.FinishLoadLayout(baseLayout);
    if (list.length > 0) {
      this.AttachTopDBObjToLayout(layout);
      layout.UpdateForFieldList(list, doc, baseLayout);
      if (this.fParentPanel) this.fParentPanel.DoAfterBoxUpdate();
      return true;
    }
    return false;
  }

  // Used for interactive preview
  AttachTopDBObjToLayout(layout) {
    var doc = this.fWSMgr.GetDoc();
    layout.SetDocRef(doc);
    var scm = doc.GetSubChartMgr();
    var curSC = scm.GetCurrentSubChart();
    var previewDBObj = curSC.GetTopDBObj();
    // NOTE: Cells use parent layout db obj ref for layout calc - chart boxes have their own db obj ref for displaying vals.
    // this mirrors references stored when editing box layouts via layout editor.
    if (layout.GetDBObj() == null && previewDBObj != null) layout.SetDBObj(previewDBObj);
    return previewDBObj;
  }
}
